import { allServicesCountryReducer } from '../models/country.interface';
import { FETCH_ALL_SERVICES_COUNTRY_LOADING, FETCH_ALL_SERVICES_COUNTRY_SUCCESS, FETCH_ALL_SERVICES_COUNTRY_FAILED } from '../actions/pricing.action';

const initialState: allServicesCountryReducer = {
    servicesCountryData: {
        sms: [],
        voice: []
    },
    servicesCountryLoading: true,
    servicesCountryError: false,
    servicesCountryMsg: ""

}

const allServicesCountries = (state: allServicesCountryReducer = initialState, action: any) : allServicesCountryReducer => {
    switch (action.type) {
        case FETCH_ALL_SERVICES_COUNTRY_LOADING:
            return {
                ...state,
                servicesCountryLoading: true,
                servicesCountryError: false,
                servicesCountryMsg: ""
            }
        case FETCH_ALL_SERVICES_COUNTRY_SUCCESS:
            return {
                ...state,
                servicesCountryData: action.payload.res.data,
                servicesCountryLoading: false,
                servicesCountryError: false,
                servicesCountryMsg: ""
            }
        case FETCH_ALL_SERVICES_COUNTRY_FAILED:
            return {
                ...state,
                servicesCountryLoading: false,
                servicesCountryError: true,
                servicesCountryMsg: action.payload.error.message || ""
            }
        default:
            return state;
    }
}

export default allServicesCountries;